import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import {
  AssessmentVersionsRef,
  AssessmentsRef,
} from '../../../util/refs';

import {
  getIcon,
  getOptionValueForSelect,
  unwrapDoc,
  unwrapDocs,
  excludeTestAssessments,
} from '../../../util';

import { Switch } from '../../shared';

import {
  fetchPublicUserDataForAssessmentOrganization
} from '../../../actions';

import { talentProfiles } from '../../../data/talentProfiles';
import { dimensions } from '../../../data/dimensions';

import {
  scoreAssessmentForExport
} from '../../../util/assessmentScoring';

import {
  fetchAssessmentConfigs
} from '../../../actions/admin';

import Select from 'react-select';

class AssessmentPlaybooksExportTool extends Component{

  state = {
    assessmentConfigs: null,
    selectedAssessment: null,
    selectedTalentProfile: null,
    includeOtherProfileAssessments: false,
    preparingLinks: false,
    playbooks: null,
    publicUserData: null,
    deprecatedScoring: false,
  }

  componentDidMount(){
    fetchAssessmentConfigs(assessmentConfigs => {
      this.setState({
        assessmentConfigs
      });
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState.selectedAssessment !== this.state.selectedAssessment){
      this.setState({
        selectedTalentProfile: null,
        playbooks: null,
        includeOtherProfileAssessments: false,
      });

      //fetch employee data if we select different assessment - as it could be for different organization
      this.fetchUserData();
    }
     else if( prevState.selectedTalentProfile !== this.state.selectedTalentProfile ||
              prevState.includeOtherProfileAssessments !== this.state.includeOtherProfileAssessments ||
              prevState.deprecatedScoring !== this.state.deprecatedScoring
    ){
       this.setState({
         playbooks: null,
       });
     }
  }

  currentlySelectedAssessment(){
    return _.find(this.state.assessmentConfigs || [], { _id: this.state.selectedAssessment }) || null;
  }

  renderAssessmentConfigSelect(){
    if(!this.state.assessmentConfigs){
      return 'Loading...'
    }

    const assessmentConfigOptions = _.map(this.state.assessmentConfigs, config => {
      return {
        label: config.name,
        value: config._id
      }
    });

    return (
      <Select
        placeholder="Select an Assessment..."
        classNamePrefix={'react-select'}
        className='react-select-container reports-require-role'
        value={getOptionValueForSelect(assessmentConfigOptions, this.state.selectedAssessment)}
        options={assessmentConfigOptions}
        onChange={(option) => { this.setState({ selectedAssessment: option.value }); }}
        isSearchable={false}
      />
    )
  }

  renderAssessmentProfileSelect(){

    const assessmentProfileOptions = _.map(this.currentlySelectedAssessment().profileNames, (id, name) => {
      return {
        label: name,
        value: id
      }
    });

    return (
      <Select
        placeholder="Select a Talent Profile..."
        classNamePrefix={'react-select'}
        className='react-select-container reports-require-role'
        value={getOptionValueForSelect(assessmentProfileOptions, this.state.selectedTalentProfile)}
        options={assessmentProfileOptions}
        onChange={(option) => { this.setState({ selectedTalentProfile: option.value }); }}
        isSearchable={false}
      />
    )
  }

  renderAssessmentConfigOption(){
    return (
      <div className="export-option">
        <div className="export-option-label">Assessment</div>
        <div className="export-option-value">
          {this.renderAssessmentConfigSelect()}
        </div>
      </div>
    )
  }

  renderDeprecatedScoringOption(){

    const {
      deprecatedScoring
    } = this.state;

    return (
      <div className="export-option">
        <div className="export-option-label">Use Deprecated Scoring</div>
        <div className="export-option-value">
        <Switch
          id="enable-deprecated-scoring"
          checked={deprecatedScoring || false}
          onChange={checked => { this.setState({ deprecatedScoring: checked }); } }
        />
        </div>
      </div>
    )
  }

  renderIncludeAssessmentsFromOtherProfilesSelect(){

    const options = [{
      label: `Only this profile (${this.state.selectedTalentProfile})`,
      value: false
    },{
      label: 'Include all profiles',
      value: true
    }];

    return (
      <Select
        placeholder="..."
        classNamePrefix={'react-select'}
        className='react-select-container reports-require-role'
        value={getOptionValueForSelect(options, this.state.includeOtherProfileAssessments)}
        options={options}
        onChange={(option) => { this.setState({ includeOtherProfileAssessments: option.value }); }}
        isSearchable={false}
      />
    )
  }

  renderExportDataOptions(){

    const {
      selectedTalentProfile
    } = this.state

    return (
      <React.Fragment>
        <div className="export-option">
          <div className="export-option-label">Profile</div>
          <div className="export-option-value">
            {this.renderAssessmentProfileSelect()}
          </div>
        </div>
        {selectedTalentProfile &&
          <div className="export-option">
            <div className="export-option-label">Include assessment data from...</div>
            <div className="export-option-value">
              {this.renderIncludeAssessmentsFromOtherProfilesSelect()}
            </div>
          </div>
        }
      </React.Fragment>
    )
  }

  currentlySelectedTalentProfile(){
    if(!this.state.selectedTalentProfile){
      return null;
    }

    return talentProfiles[this.state.selectedTalentProfile];
  }

  getDimensionLabel(dimensionId){
    //todo get localized version of this if need be!
    return dimensions[dimensionId].label;
  }

  generatePlaybookDownloadLinks(){
    if(this.state.preparingLinks){
      return;
    }

    this.setState({ preparingLinks: true });

    const {
      selectedAssessment,
      selectedTalentProfile,
      includeOtherProfileAssessments,
    } = this.state;

    const profileWhereClauseArgs = includeOtherProfileAssessments ? ['status', '==', 'scored'] : ['assessmentConfig.profile', '==', selectedTalentProfile];

    AssessmentVersionsRef().doc(this.currentlySelectedAssessment().assessmentVersion).get().then(doc => {
      const assessmentVersion = unwrapDoc(doc);

      //fetch all assessments with critera for assessment
      AssessmentsRef().where('assessmentConfig.assessmentName', '==', selectedAssessment).where('status', '==', 'scored').where(...profileWhereClauseArgs).get().then(docs => {
        const assessments = unwrapDocs(docs);

        const realAssessments = excludeTestAssessments(assessments);

        console.log('found assessments', assessments);

        const scoredAssessments = _.map(realAssessments, assessment => {

          let assessmentScores;

          if(this.state.deprecatedScoring){
            //Deprecated - buggy scoring w/ reverse scored items
            assessmentScores = scoreAssessmentForExport(assessment.responses, assessmentVersion, selectedTalentProfile, '1');
          }
          else{
            //Fixed - reverse scored items scored correctly
            assessmentScores = scoreAssessmentForExport(assessment.responses, assessmentVersion, selectedTalentProfile);
          }

          return {
            assessment: assessment.assessmentConfig.assessmentName,
            assessmentConfig: assessment.assessmentConfig,
            originalProfile: assessment.assessmentConfig.profile,
            userId: assessment.userId,
            user: this.dataForUser(assessment.userId),
            scoredProfile: selectedTalentProfile,
            dimensionScores: assessmentScores.profileDimensionScores,
          }
        });

        console.log('assessments with scores: ', scoredAssessments);

        this.setState({
          playbooks: _.orderBy(scoredAssessments, assessment => { return assessment.user.firstName + ' ' + assessment.user.lastName }),
          preparingLinks: false,
        });
      });
    });
  }

  renderExportActions(){
    const {
      selectedAssessment,
      selectedTalentProfile,
      playbooks,
      preparingLinks,
    } = this.state;

    if(!selectedAssessment || !selectedTalentProfile){
      return null;
    }

    return (
      <div className="export-actions">
        {!playbooks &&
          <button disabled={preparingLinks} onClick={() => { this.generatePlaybookDownloadLinks(); }} className="button grey-button">Generate Playbook Download Links</button>
        }
      </div>
    )
  }

  renderPlaybookLinks(){
    const {
      playbooks,
      selectedAssessment,
      selectedTalentProfile,
    } = this.state;

    if(!playbooks){
      return null;
    }

    console.log('rendering playbook links w/ playbooks data: ', playbooks);

    return (
      <div className="playbook-links">
        {_.map(playbooks, playbook => {

          const urlArgs = {
            version: playbook.assessmentConfig.playbookVersion,
            firstName: playbook.user.firstName,
            lastName: playbook.user.lastName,
            organization: playbook.assessmentConfig.organization,
            locale: playbook.assessmentConfig.locale || "en",
            profile: selectedTalentProfile,
            scores: _.mapValues(playbook.dimensionScores, scoresForDimension => {
              return scoresForDimension.adjusted
            })
          }

          const linkForPlaybook = document.location.origin + `/export/playbook?reportData=${JSON.stringify(urlArgs)}`

          //http://localhost:3000/export/playbook?reportData=%7B"version":"1","firstName":"Test","lastName":"Export","organization":"MC3jDewWCxOCsrx7qYWa","locale":"en","profile":"o1nadu","batchLabel":"Global%20Services","scores":%7B"c54tc9":92,"ceokld":65.33,"eb2x38":58.33,"ep6tj6":44,"fdwtt7":59.5,"g5ii0e":52,"hp8cen":63.77,"jctmmw":51.33,"jrsl97":53.67,"ltu5rt":56,"moo90r":54.44,"oyzo55":72.33,"qxgy0i":64,"t9sjaz":30.33,"up7jjs":56,"x47kw5":67.2,"itypp1":56%7D%7D

          return (
            <div key={`playbook-for-${playbook.userId}`} className="playbook-link">
              <div className="name">{playbook.user.firstName} {playbook.user.lastName}</div>
              <div className="link">
                <a target="_blank" href={linkForPlaybook}>{getIcon('talents')}</a>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  selectedOrganization(){
    const selectedAssessmentConfigData = _.find(this.state.assessmentConfigs, { _id: this.state.selectedAssessment });

    return selectedAssessmentConfigData && selectedAssessmentConfigData.organization;
  }

  dataForUser(userId){
    return _.find(this.state.publicUserData, { _id: userId });
  }

  fetchUserData(){

    this.setState({
      publicUserData: null,
    });

    if(this.selectedOrganization()){
      fetchPublicUserDataForAssessmentOrganization(this.selectedOrganization(), userData => {

        this.setState({
          publicUserData: userData
        });
      });
    }
  }

  render(){

    const {
      selectedAssessment,
      selectedTalentProfile,
      playbooks,
      preparingLinks,
    } = this.state;

    if(!this.state.assessmentConfigs){
      return <p>Loading...</p>
    }

    return (
      <div className="page-section export-tool">
        <div className='export-sidebar'>
          {this.renderAssessmentConfigOption()}
          {selectedAssessment && this.renderExportDataOptions()}
          {selectedAssessment && selectedTalentProfile && this.renderDeprecatedScoringOption()}
          {selectedAssessment && this.renderExportActions()}
        </div>
        <div className='export-content'>
          {!playbooks && !preparingLinks &&
            <p>Select options on left and generate playbook links</p>
          }
          {!playbooks && preparingLinks &&
            <p>Preparing download links...</p>
          }
          {playbooks && this.renderPlaybookLinks()}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    organizations: state.organizations.data,
  }
}

export default connect(mapStateToProps, {})(AssessmentPlaybooksExportTool);



// WEBPACK FOOTER //
// ./src/components/adminexport/exportTools/assessmentPlaybooks.js